export const DLVR_FRONTEND_VERSION = '3.0.0-beta'
export const DLVR_API_TOKEN = '1xdLY5t1P92c1az0hHbJsa0CPLXURR4Qfbgspo4G8EF4rygDs2vjKW5oorrMXdc1'

export const LQ_STEPS = [
    'brand',
    'terminal',
    'order_type',
    'sum',
    'accept',
    'link'
]

export const LQ_STEPS_TITLE = [
    'Оберіть бренд',
    'Оберіть термінал',
    'Оберіть тип замовлення',
    'Введіть суму замовлення',
    'Підтвердіть дані',
    'Посилання на оплату'
]

export const BL_BRANDS = [
    {
        'key': 'bagatolososia',
        'title': 'БагатоЛосося',
        'logo': '/assets/img/logos/bagatolososia.svg'
    },
    {
        'key': 'sushiho',
        'title': 'СушіХо',
        'logo': '/assets/img/logos/sushiho.svg'
    },
    // {
    //     'key': 'bagatosyru',
    //     'title': 'БагатоСиру',
    //     'logo': '/assets/img/logos/bagatosyru.svg'
    // }
]

export const BL_ORDER_TYPES = [
    {
        'key': 'regular',
        'title': 'Звичайне замовлення',
        'icon': '/assets/img/icons/sushi.png'
    },
    {
        'key': 'alcohol',
        'title': 'Містить алкоголь',
        'icon': '/assets/img/icons/wine.png'
    }
]

export const LQ_KEYBOARD = [
    '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', '<'
]

export const BL_ORDER_STATUSES = {
    Unconfirmed: "Не підтверджений",
    WaitCooking: "Очікує на приготування",
    ReadyForCooking: "Готовий до приготування",
    CookingStarted: "Готується",
    CookingCompleted: "Приготовлений",
    Waiting: "Очікує на доставку",
    OnWay: "Доставляється",
    Delivered: "Доставлений",
    Closed: "Закритий",
    Cancelled: "Скасований"
}
